import Component from '@glimmer/component';
import { computed } from '@ember/object';
import { action } from '@ember/object';
import { reads } from '@ember/object/computed';
import { tracked } from '@glimmer/tracking';
import dispatcher from 'mewe/dispatcher';
import PagesApi from 'mewe/api/pages-api';
import { installDropdown } from 'mewe/utils/dropdown-utils';

export default class SidebarLeftPage extends Component {
  @reads('args.isOpenPage') isOpenPage;

  @tracked isPublishing;
  @tracked dropdownOptions;

  constructor() {
    super(...arguments);

    installDropdown(this, 'dropdownOptions');
  }

  @computed('args.model.page.{id,isOwnerAdmin}')
  get showReportButton() {
    return this.args.model?.page?.id && !this.args.model?.page?.isOwnerAdmin;
  }

  @action
  create() {
    dispatcher.dispatch('pages', 'create');
  }

  @action
  openReportPageDialog() {
    dispatcher.dispatch('pages', 'reportPage', { page: this.args.model?.page });
  }

  @action
  publish() {
    if (this.isPublishing) return;

    this.isPublishing = true;

    PagesApi.publish({ id: this.args.model?.page?.id })
      .then(() => {
        this.args.model.page.published = true;
      })
      .catch((response) => {
        if (response && response.status === 403) {
          dispatcher.dispatch('pages', 'buySubscriptionAlert', this.args.model.page);
        }
      })
      .then(() => this.isPublishing = false);
  }
}
